// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/styles/reset.css' /*重置默认样式*/
//import '../static/styles/common.css' /*引入公共样式 媒体查询*/
import '../static/styles/clearfix.css' /*清除浮动*/

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js